import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AuctionBidAdmin } from '../../models/auctionBidAdmin';
import { UserBasicDataResponse } from '../../responses/userBasicDataResponse';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { AuctionService } from '../../services/AuctionService';
import { take } from 'rxjs';
import { BasicResponse } from '../../responses/basicResponse';
import { BrokerInfoDTO } from '../../DTO/brokerInfoDTO';
import { BrokerInfo } from '../../models/brokerInfo';
import { AuthenticationService } from '../../services/AuthenticationService';

@Component({ standalone: false,
  selector: 'user-contact-dialog',
  templateUrl: 'user-contact-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['user-contact-dialog.component.scss']
})
export class UserContactDialogComponent {
  public confirmButtonText = "OK";
  public user!:UserBasicDataResponse;
  public userBids?:AuctionBidAdmin[];
  public auctionIsLive:boolean = false;
  public brokerInfo?:BrokerInfo;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<UserContactDialogComponent>, private dialog: MatDialog, private auctionService:AuctionService, private authService:AuthenticationService) {
    if(data){
        this.user = data.user;
        this.userBids = data.userBids;
        this.auctionIsLive = data.auctionIsLive;
        if(data.brokerageId){
          this.authService.getBrokerInfo(data.brokerageId).pipe(take(1)).subscribe((dto:BrokerInfoDTO)=>{
            this.brokerInfo = BrokerInfo.mapFromDTO(dto);
          });
        }
        else if(this.userBids?.length && this.userBids[0].representingBrokerId){
          this.authService.getBrokerInfo(this.userBids[0].representingBrokerId).pipe(take(1)).subscribe((dto:BrokerInfoDTO)=>{
            this.brokerInfo = BrokerInfo.mapFromDTO(dto);
          });
        }
    }
  }

  get addressLine1():string{
    return this.user?.streetAddress1 + ', ' + ((this.user?.streetAddress2?.length)?(this.user?.streetAddress2 +', '):'');
  }

  get addressLine2():string{
    return this.user?.city + ', ' + this.user?.state + ' ' + this.user?.zipCode;
  }

  get displayedColumns(){
    return ['amount', 'time','proxy','equalized'];
  }

  get currentProxyAmount(){
    if(!this.auctionIsLive) return undefined;
    if(!this.userBids?.length) return undefined;
    let sortedBids = this.userBids.sort((a,b) => Math.max(a.currentBid,b.currentBid));
    return sortedBids?((sortedBids[0].currentBid<sortedBids[0].bidAmount)?sortedBids[0].bidAmount:undefined):undefined;
  }

  get canUseNotes(){
    return this.authService.currentUserValue!.isSuperAdmin;
  }

  onRemoveProxyClick(){
    this.confirmDialog();
  }

  private confirmDialog(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data={title: "Remove Proxy Bid", message: "Are you sure you want to remove this proxy bid?", buttonText: {ok: "YES", cancel: "NO"}, needReason:true};
    this.dialog.open(ConfirmationDialogComponent,  dialogConfig).afterClosed().subscribe(value=>{
      if(value){
        this.auctionService.equalizeUserBidForAuction(this.user!.id, this.userBids![0].auctionId, value).pipe(take(1)).subscribe((r:BasicResponse)=>{
          this.dialogRef.close(true); //set to true to indicate that calling component needs to refresh data
        });
      }
    });
  }

  onConfirmClick(): void {
    this.dialogRef.close(false);
  }

}